import { TranslateService } from "@ngx-translate/core";

/**
 * Resolves and normalizes "without client/project" placeholder labels.
 */
export class SignalrLabelResolverUtil {
	private static readonly clientFallbackLabel = "Without customer";
	private static readonly projectFallbackLabel = "Without project";

	private static readonly knownClientLabels = new Set<string>([
		"No Client",
		"Without Client",
		"Without customer",
		"Ohne Kunde",
	]);
	private static readonly knownProjectLabels = new Set<string>([
		"No Project",
		"Without Project",
		"Without project",
		"Ohne Projekt",
	]);

	static resolveClientLabel(translateService: TranslateService): string {
		const translatedLabel = translateService.instant("client.none");
		return typeof translatedLabel === "string" && translatedLabel !== "client.none"
			? translatedLabel
			: this.clientFallbackLabel;
	}

	static resolveProjectLabel(translateService: TranslateService): string {
		const translatedLabel = translateService.instant("project.none");
		return typeof translatedLabel === "string" && translatedLabel !== "project.none"
			? translatedLabel
			: this.projectFallbackLabel;
	}

	static isWithoutClientLabel(value: string): boolean {
		return typeof value === "string" && this.knownClientLabels.has(value.trim());
	}

	static isWithoutProjectLabel(value: string): boolean {
		return typeof value === "string" && this.knownProjectLabels.has(value.trim());
	}
}
